import { QueryClient } from "@tanstack/react-query";

// Shared singleton so non-React modules (e.g. `logout()`) can invalidate caches.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});
